import React from "react";
import "./CaseStudies.css";
import { useParams } from "react-router-dom";

const allCaseStudiesData = {
  "ai-voice-assistant-ai-agent": [
    {
      id: 1,
      title: "01 - AI Customer Support Automation Software",
      videoUrl: "https://www.youtube.com/embed/z0f0rgrCFxg",
      features: [
        "Customizable AI Chatbot",
        "Leads Management Dashboard",
        "Detailed AI Analytics",
        "Manage Customer Support Teams",
      ],
    },
    {
      id: 2,
      title: "02 - AI Language Tutor Voice Bot",
      videoUrl: "https://www.youtube.com/embed/EIjnyVEclKM",
      features: [
        "Real-Time Data Reporting",
        "Custom Dashboard Creation",
        "Advanced Audience Segmentation",
        "Automated Campaign Optimization",
      ],
    },
  ],
  "web-development": [
    {
      id: 3,
      title: "03 - Advanced Web Application Portfolio",
      videoUrl: "https://www.youtube.com/embed/EIjnyVEclKM",
      features: [
        "Modern UX/UI Design",
        "High Performance",
        "Responsive Layouts",
        "SEO Optimized",
      ],
    },
  ],
  "mobile-app-development-android-ios-hybrid-apps": [
    {
      id: 4,
      title: "04 - Mobile App Revolution",
      videoUrl: "https://www.youtube.com/embed/EIjnyVEclKM",
      features: [
        "Cross-Platform Excellence",
        "Native Feel Experience",
        "Seamless Integration",
        "User-Friendly Interfaces",
      ],
    },
  ],
  "machine-learning-deep-learning-solutions": [
    {
      id: 5,
      title: "05 - Predictive Analytics & ML Insights",
      videoUrl: "https://www.youtube.com/embed/EIjnyVEclKM",
      features: [
        "Data-Driven Decision Making",
        "Custom ML Models",
        "Real-time Analytics",
        "Scalable Deployments",
      ],
    },
  ],
};

export default function CaseStudies() {
  const { slug } = useParams();
  const defaultCaseStudies = Object.values(allCaseStudiesData)[0] || [];
  const caseStudiesData = allCaseStudiesData[slug] || defaultCaseStudies;

  return (
    <div className="service-casestudies">
      <div className="container-fluid">
        <h1>Learn from Our Case Studies</h1>

        {caseStudiesData.map((item, index) => {
          const isContentLeft = index % 2 === 0;
          return (
            <div
              className="service-casestudies-content"
              style={{ flexDirection: !isContentLeft ? "row-reverse" : "" }}
            >
              <div
                className="service-casestudies-left"
                style={{ justifyContent: !isContentLeft ? "end" : "start" }}
              >
                <div className="service-casestudies-left-wrap">
                  <div
                    className="service-casestudies-header"
                    style={{
                      borderTopRightRadius: isContentLeft ? "50px" : "0px",
                      borderTopLeftRadius: !isContentLeft ? "50px" : "0px",
                    }}
                  >
                    <h2>{item.title}</h2>
                  </div>

                  <div className="service-casestudies-features">
                    <ul>
                      <li>
                        <h3>Key Features</h3>
                      </li>
                    </ul>
                    <ul>
                      {item.features.map((feature, idx) => (
                        <li key={idx}>
                          <div className="feature-number">{idx + 1}</div>
                          <div className="feature-text">{feature}</div>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>

              <div className="service-casestudies-right">
                <iframe
                  width="100%"
                  height="100%"
                  className="service-casestudies-iframe"
                  title={item.title}
                  src={item.videoUrl}
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowFullScreen={true}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
